module.exports = __webpack_public_path__ + "c86d0016be00c71716fdeba17b7e916f.svg";